import { Slider as SliderComponent } from "antd"
import { useMemo } from "react"
import type { SliderSingleProps } from "antd"

type Props = {
	marks: SliderSingleProps["marks"]
	step: number | null
	min: number
	max: number
	value?: number | number[]
	onChange?: (value: number | number[]) => void
}

export const Slider = ({ marks, step, min, max, value, onChange }: Props) => {
	// Transform marks to add data-testid to each mark label
	const marksWithTestId = useMemo(() => {
		if (!marks) return marks

		const transformedMarks: SliderSingleProps["marks"] = {}
		Object.entries(marks).forEach(([key, label]) => {
			if (label === null || label === undefined) {
				transformedMarks[Number(key)] = label
				return
			}

			const markValue = typeof label === "object" && "label" in label ? label.label : label
			transformedMarks[Number(key)] = <span data-testid={`slider-item-${label}`}>{markValue as React.ReactNode}</span>
		})
		return transformedMarks
	}, [marks])

	return (
		<SliderComponent
			range
			marks={marksWithTestId}
			step={step}
			min={min}
			max={max}
			value={value as number[]}
			onChange={onChange as (value: number[]) => void}
		/>
	)
}
